<script setup lang="ts">
import { computed, ref, watch, onMounted } from 'vue'
import fallbackImage from '@/assets/error-image.svg'
import defaultImage from '@/assets/default-image.svg'
import { Viewer } from '@photo-sphere-viewer/core'
import '@photo-sphere-viewer/core/index.css'
import TimesIcon from '@primevue/icons/times';

interface Props {
  id?: string,
  src?: string,
  alt?: string,
  width?: string,
  height?: string,
  preview?: boolean
  previewSrc?: string
  type?: string
}
const props = defineProps<Props>()
const viewerContainer = ref('');

const _id = computed(() => props.id)

const _preview = computed(() => props.preview)

const _source = ref<string>(props.src || defaultImage)
const _source_preview = ref<string>(props?.previewSrc || defaultImage)

const _class = computed(() => {
  return 'cs_image'
})

const _style = computed(() => {
  return ''
})

const onError = () => {

  _source.value = fallbackImage
}

watch(() => props.src, (newVal) => {

  if (newVal) {
    _source.value = newVal
  }
})

watch(() => props.previewSrc, (newVal) => {
  if (newVal) {
    _source_preview.value = newVal
  }
})

watch(() => props, (newVal) => {
  console.log(123123, newVal)
})

const show = ref(false)
const onShowPreview = () => {
  show.value = true
  setTimeout(() => {
    if (props.type === 'panorama' && props.preview && props.previewSrc && props.src) {
      console.log('Initializing panorama viewer with src:', props.src, 'and previewSrc:', props.previewSrc);
      new Viewer({
        container: viewerContainer.value,
        panorama: props.previewSrc || props.src,
      })
    }
  }, 100)
}
</script>

<template>
  
  <Image alt="Image" :preview="_preview && props.type !== 'panorama'" :id="_id">
    <template #previewicon>
      <i class="pi pi-search"></i>
    </template>
    <template #image>
      <img
        :src="_source"
        :alt="props.alt || 'default image'"
        :width="props.width"
        :height="props.height"
        :class="_class"
        :style="_style"
        @error="onError"
        @click="onShowPreview"
      />
    </template>
    <template #preview="slotProps">
      <template v-if="props.type !== 'panorama'">
        <img
          :src="_source_preview || _source"
          :alt="props.alt || 'default image'"
          :width="props.width"
          :height="props.height"
          :class="`${_class} max-w-screen max-h-screen`"
          :style="slotProps.style + '' + _style"
          @error="onError"
          @click="slotProps.onClick"
          lazyload="eager"
        />
      </template>
    </template>
  </Image>

  <div
    v-if="props.type === 'panorama' && show"
    class="fixed top-0 left-0 h-screen w-screen z-100 p-image-mask p-overlay-mask"
  >
    <div class="absolute top-8 right-8 p-image-toolbar">
      <button class="p-image-action p-image-close-button cursor-pointer" @click="show = false">
        <TimesIcon />
      </button>
    </div>
    <div
      ref="viewerContainer"
      style="width: 700px; height: 500px;"
      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>
  </div>

</template>

<style scoped>

</style>
